import { BoxProps } from "@chakra-ui/react";
import { CloseIcon } from "../../../svg";
import { Button } from "./CloseButon.styles";

export const CloseButton = (props: BoxProps & { hasError: boolean }) => (
  <Button {...props}>
    <CloseIcon />
  </Button>
);
